// extracted by mini-css-extract-plugin
module.exports = {"header__account-label":"HeaderAccount_header__account-label__V1BaB"};